import React from 'react';
import { Background as BackgroundImage } from 'react-imgix';
import { createCrop } from 'utils/image';
import styled from 'styled-components';
const BackgroundColor = styled.div `
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
const BackgroundMedia = ({ className = '', media, children, }) => {
    if (!media) {
        return React.createElement("div", { className: className }, children);
    }
    if (media.__typename === 'ImageType' && media.url) {
        const cropParams = createCrop(media.crop);
        return (React.createElement(BackgroundImage, { className: className, src: media.url, imgixParams: cropParams.length ? { rect: cropParams } : {} }, children));
    }
    if (media.__typename === 'ColorType') {
        return (React.createElement(BackgroundColor, { className: className, backgroundColor: media.hexCode }, children));
    }
    return React.createElement("div", { className: className }, children);
};
export default BackgroundMedia;
